export const coach = {
  "coach.custom-playlists.title": "Listas de reproducción personalizadas",
  "coach.custom-playlists.description": "Entrena con listas de reproducción personalizadas creadas para ti",
  "coach.scenario-editor.title": "Editor de escenarios",
  "coach.scenario-editor.description": "Crea y edita escenarios personalizados",
  "coach.bybcat.description": "Mide tu rendimiento con una prueba personalizada",
  "coach.club-feature": "Función para clubes",
};
